// Public, deploy-stable identifiers. Nothing here is a secret or env-overridable.
export const PRIMARY_ROOT_DOMAIN = 'mygenius.ng';
/** Served in full since 2026-10-04; links follow whichever apex this page is on. */
export const ALTERNATE_ROOT_DOMAIN = 'mygenius.com.ng';
function currentRootDomain(): string {
  if (typeof window === 'undefined') return PRIMARY_ROOT_DOMAIN;
  const host = window.location.hostname.toLowerCase();
  return host === ALTERNATE_ROOT_DOMAIN || host.endsWith(`.${ALTERNATE_ROOT_DOMAIN}`)
    ? ALTERNATE_ROOT_DOMAIN
    : PRIMARY_ROOT_DOMAIN;
}
export const ROOT_DOMAIN = currentRootDomain();
export const GAMES_ORIGIN = `https://games.${ROOT_DOMAIN}`;
export const WEB_ORIGIN = `https://${ROOT_DOMAIN}`;
export const APP_ORIGIN = `https://app.${ROOT_DOMAIN}`;
export const PRODUCT_NAME = 'My Genius Games';
export const GOOGLE_CLIENT_ID =
  '676335389272-kj3h19via1cqamprls3ng5e0dtd9m9m2.apps.googleusercontent.com';
export const LOGO_URL =
  'https://res.cloudinary.com/duuu5uos5/image/upload/f_auto,q_auto,w_96,h_96,c_fill/v1772586865/My_Genius_ICON_logo_psfwhs.png';

export const ROUTES = {
  catalog: '/',
  leaderboard: '/leaderboard/',
  smartDrive: '/smart-drive/',
  previousLaneShift: '/lane-shift/',
} as const;
